import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine6 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
			fill: "#82DC73"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1733 14.2933C16.1733 12.0225 14.5558 10.6972 12.5773 10.6972C11.2869 10.6972 10.5126 11.1619 10.0996 11.5232C10.2546 9.07998 11.5105 7.85827 13.1794 7.85827C13.8679 7.85827 14.4872 8.01298 14.8141 8.15072L15.1926 6.08607C14.6936 5.96555 14.0742 5.8797 13.3858 5.8797C9.56614 5.8797 7.62177 8.77031 7.62177 12.9859C7.62177 16.2034 8.79183 18.4914 12.061 18.4914C14.5558 18.4914 16.1733 16.7195 16.1733 14.2933ZM13.7476 14.5515C13.7476 15.6011 13.1452 16.5817 11.9751 16.5817C10.7706 16.5817 10.1169 15.4631 10.1169 14.3105C10.1169 13.9494 10.1169 13.4848 10.2546 13.2784C10.4954 12.8996 11.0975 12.6072 11.8374 12.6072C13.0075 12.6072 13.7476 13.4157 13.7476 14.5515Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine6);
export { ForwardRef as ReactComponent };
